import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideRouter, withHashLocation } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { provideAngularSvgIcon } from 'angular-svg-icon';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';

import { AppService } from '@core/services/app.service';
import { AppLayoutModule } from './layout/app.layout.module';
import { TokenInterceptor } from './core/interceptors/token.interceptor';
import { provideStore } from '@ngrx/store';
import { routes } from './app.routes';
import appTheme from './app.theme';

import { featureKey as quoteFeatureKey, reducers as quoteReducers } from '@shared/store/quotes/quote.reducers';
import { featureKey as sessionFeatureKey, reducers as sessionReducers } from '@shared/store/session/session.reducers';
import { featureKey as appFeatureKey, reducers as appReducers } from '@shared/store/app/app.reducers';

export const appConfig: ApplicationConfig = {
  providers: [
    provideStore({
      [appFeatureKey]: appReducers,
      [sessionFeatureKey]: sessionReducers,
      [quoteFeatureKey]: quoteReducers
    }),
    provideZoneChangeDetection({ eventCoalescing: true }),
    importProvidersFrom(BrowserAnimationsModule, BrowserModule, FormsModule, AppLayoutModule, ToastModule),
    provideRouter(routes, withHashLocation()),
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    provideAnimationsAsync(),
    providePrimeNG({
      theme: appTheme,
      ripple: true,
      inputVariant: 'outlined'
    }),
    provideAngularSvgIcon(),
    MessageService,
    { provide: 'BASE_URL', useFactory: () => document.getElementsByTagName('base')[0].href, deps: [] },
    AppService
  ]
};
